export default {
  primary: '#A32427',
  primaryLight: '#bd6264',
  primaryLight2: '#b04345',
  primaryLight3: '#bd6264',
  primaryDark: '#6D0000',
  secondary: '#546E7A',
  secondaryLight: '#BBDCEA',
  secondaryDark: '#29434E',
  grayLight: '#f3f3f3',
  grayMedium: '#E0E0E0',
  grayDark: '#9A9A9A',
  accent: '#279022',
  info: '#3394D5',
  infoDark: '#0061a2',
  successLight: '#4caf50',
  successDark: '#388e3c',
  warningLight: '#ff9800',
  errorLight: '#ef5350',
  rightBarBg: '#464646',
  rightBarBgLight: '#757575',
  rightBarBgLight2: '#575757',
  rightBarBgLight3: '#5d5d5d',
  white: '#fff',
  black: '#000',
  dashboardStatAll: '#2ea4fe',
  dashboardStatAllDark: '#0c82dc',
  dashboardStatWorking: '#15c38e',
  dashboardStatWorkingDark: '#03a16c',
  dashboardStatNotActive: '#f55253',
  dashboardStatNotActiveDark: '#d33031',
  dashboardStatNotWorking: '#c7c7c7',
  dashboardStatNotWorkingDark: '#908f8d',
  highlightDark: '#ffcc00',
  highlightLight: '#eeaa00',
}
